<template>
  <div>
    <div class="mt-4 px-2">
      <template v-if="step === 2">
        <div class="d-flex align-center">
          <v-btn text icon color="cyan" @click="back">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <span>請選擇畜主{{ user.name }}的寵物</span>
        </div>
      </template>
    </div>
    <div v-if="step === 1" class="pa-2">
      <breeder-search :clinic="clinic" @search="search"></breeder-search>
      <qr-code-hint class="mt-4" hint="或是你可使用Line內建#掃一掃NxVet網頁中，寵物大頭照下方的專屬條碼"></qr-code-hint>
    </div>
    <div v-if="step === 2" class="px-2">
      <type-tab class="mt-4" v-model="tab"></type-tab>
      <card-pet
        :phone="phone"
        style="margin-left:-4px;margin-right:-4px"
        class="mt-4"
        ref="cardPet"
        :clinic="clinic"
        @onSelect="onSelect"
        :filter="tab"
      ></card-pet>
    </div>
  </div>
</template>
<style scoped></style>
<script>
import CardPet from "../common/CardPet";
import BreederSearch from "./component/BreederSearch";
import TypeTab from "./component/TypeTab";
import QrCodeHint from "./component/QrCodeHint";

export default {
  props: ["clinic"],
  components: {
    CardPet,
    BreederSearch,
    TypeTab,
    QrCodeHint
  },
  data: () => ({
    profile: {},
    user: {},
    params: {},
    phone: "",
    tab: "all",
    step: 1
  }),
  methods: {
    async onSelect(petId) {
      console.log("onSelect petId:" + petId);
      await this.$ajax.post(
        `${this.$config.apiUrl}/${this.clinic}/liff/bot/${this.profile.userId}`,
        {
          action: this.params.action,
          selectId: petId
        }
      );
      if (this.$liff.isInClient()) {
        this.$liff.closeWindow();
      } else {
        window.location.href = `line://oaMessage/${this.params.botId}/`;
      }
    },
    async getUser() {
      let response = await this.$ajax.post(
        `${this.$config.apiUrl}/${this.clinic}/search/user`,
        { phone: this.phone }
      );
      this.user = response.data[0];
    },
    async getProfile() {
      if (process.env.NODE_ENV === "development") {
        this.profile.userId = "Udef0da4cc49048f0ae7adf34dad40ec6";
      } else {
        this.profile = await this.$liff.getProfile();
        // this.profile.userId = "Udef0da4cc49048f0ae7adf34dad40ec6";
      }
    },
    async search(phone) {
      this.phone = phone;
      await this.getUser();

      let response = await this.$ajax.get(
        `${this.$config.apiUrl}/${this.clinic}/pets/${this.phone}/0`
      );
      this.petNum = response.data.length;
      if (this.petNum === 1) {
        //customer only has one pet
        this.onSelect(response.data[0]._id);
      } else {
        this.tab = "all";
        this.step = 2;
      }
    },
    async back() {
      this.step--;
      await this.$nextTick();
    }
  },
  async mounted() {
    //liff init
    await this.$liff.init({ liffId: this.params.liffId });
    if (process.env.NODE_ENV === "development") {
      await this.getProfile();
    } else if (this.$liff.isInClient() || this.$liff.isLoggedIn()) {
      //in line app or user already login
      await this.getProfile();
    } else {
      //in external web and not login
      this.$liff.login();
    }
  },
  async created() {
    ///liff/selectUserPet/ladyicats?liffId=1491223853-wkP6G72P&botId=@gnx4787y&action=setAvatar

    //parse url parameter
    const url = new URL(window.location.href);
    let thisVm = this;
    for (let [key, value] of url.searchParams.entries()) {
      thisVm.params[key] = value;
    }
    console.log("params:" + JSON.stringify(thisVm.params));

    if (!this.params.liffId) {
      alert("liffId undefined");
    }

    if (!this.params.botId) {
      alert("botId undefined");
    }
  }
};
</script>
